import * as React from 'react';
import { LogoCentered } from 'src/app/Partials';
import PrivacyContentDe from './Privacy.Content.de';
import { assignLanguage, GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { AvailableLanguagesExtended } from 'franke-trough-dependencies';

export interface PrivacyConentProps {
  userData: GlobalPrivateState['userData'];
}

export class PrivacyContentPartial extends React.Component<PrivacyConentProps, any> {
  public render() {
    const fallbackLang = assignLanguage(navigator.language as AvailableLanguagesExtended) || 'en';
    const lang: any = this.props.userData && this.props.userData.result && this.props.userData.result.lang.split('-')[0] || fallbackLang;

    return (
      <div>
        <div className="row m-0">
          <div className="content-wrap">
            <div className="mb-4">
              <LogoCentered />
            </div>
            <PrivacyContentDe />
          </div>
        </div>
      </div>
    );
  }
}

export const PrivacyContent = connect((state: GlobalPrivateState) => ({
  userData: state.userData
}))(PrivacyContentPartial);

export default PrivacyContent;